import { useState, MouseEvent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
import { useUnmount } from 'react-use';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import styles from './AdminEditForm.module.scss';
import { KnmTypeEditForm } from './KnmTypeEditForm';
import { KnmKindEditForm } from './KnmKindEditForm';
import { KnmFormEditForm } from './KnmFormEditForm';
import { KnmSubjectTypeEditForm } from './KnmSubjectTypeEditForm';
import { KnmViolationTypeEditForm } from './KnmViolationTypeEditForm';
import { KnmNoticeMethodEditForm } from './KnmNoticeMethodEditForm';
import { KnmInspectorTypeEditForm } from './KnmInspectorTypeEditForm';
import { KnmDelegateTypeEditForm } from './KnmDelegateTypeEditForm';
import { RiskCategoryTypeEditForm } from './RiskCategoryEditForm';
import { TestPurchaseMethodTypeEditForm } from './TestPurchaseMethodEditForm';
import { KnmAddressTypeEditForm } from './KnmAddressTypeEditForm';
import { OrganizationsAndFunctionsEditForm } from './OrganizationsAndFunctionsEditForm';
import { adminSetCatalogName } from '../actions/adminAction';
import { KnmReasonCanceledEditForm } from './KnmReasonCanceledEditForm';
import { KnmRemarkEditForm } from './KnmRemarkEditForm';

function getCatalogs(onBack: () => void): ICatalog[] {
  return [
    {
      name: 'Типы КНМ',
      component: <KnmTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Виды КНМ',
      component: <KnmKindEditForm onBack={onBack} />,
    },
    {
      name: 'Формы проведения КНМ',
      component: <KnmFormEditForm onBack={onBack} />,
    },
    {
      name: 'Типы субъектов КНМ',
      component: <KnmSubjectTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Характеры выявленных нарушений',
      component: <KnmViolationTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Способы уведомления',
      component: <KnmNoticeMethodEditForm onBack={onBack} />,
    },
    {
      name: 'Тип проверяющего',
      component: <KnmInspectorTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Тип представителя проверяемой организации',
      component: <KnmDelegateTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Категории риска',
      component: <RiskCategoryTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Замечания',
      component: <KnmRemarkEditForm onBack={onBack} />,
    },
    {
      name: 'Способ проведения контрольной закупки',
      component: <TestPurchaseMethodTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Тип места проведения КНМ',
      component: <KnmAddressTypeEditForm onBack={onBack} />,
    },
    {
      name: 'Организации и функции ФРГУ',
      component: <OrganizationsAndFunctionsEditForm onBack={onBack} />,
    },
    {
      name: 'Основания отмены проверки',
      component: <KnmReasonCanceledEditForm onBack={onBack} />,
    },
  ];
}

interface ICatalog {
  name: string;
  component: JSX.Element;
}

export const AdminCatalogs = () => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [selectedCatalog, setSelectedCatalog] = useState<ICatalog | undefined>();

  useUnmount(() => {
    dispatch(adminSetCatalogName());
  });

  const onBack = useCallback(() => setSelectedCatalog(undefined), []);

  const onRowClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      const { name } = event.currentTarget.dataset;
      const catalog = getCatalogs(onBack).find(c => c.name === name);

      setSelectedCatalog(catalog);
    },
    [onBack],
  );

  if (selectedCatalog !== undefined) {
    return selectedCatalog.component;
  }

  return (
    <div className={styles.Table}>
      <span className={styles.Header}>Справочник</span>
      {getCatalogs(onBack).map(catalog => (
        <button
          key={catalog.name}
          data-name={catalog.name}
          className={styles.DataRow}
          onClick={onRowClick}
          type="button"
        >
          {catalog.name}
        </button>
      ))}
    </div>
  );
};
